import { parseDate } from './utils'

export default class TransportInfo {
	static fromJSON(json) {
		if (!json) return null

		return new TransportInfo(json.requisitionId)
			.withTransportType(json)
			.withClinicalProcessId(json)
			.withTransportDateStr(json)
			.withApplicantProcessId(json)
			.withEstablishmentName(json)
			.withEstablishmentId(json)
			.withState(json)
			.withCreationDate(json)
			.withMedicalSpecialty(json)
			.withOriginRequisition(json)
	}

	constructor(id) {
		this.requisitionId = id
	}

	withOriginRequisition(json) {
		this.originRequisition = json.originRequisition
		return this
	}

	withMedicalSpecialty(json) {
		this.medicalSpecialty = json.medicalSpecialty
		return this
	}

	withCreationDate(json) {
		this.createDate = json.creationDate
			? parseDate(json.creationDate)
			: null
		return this
	}

	withClinicalProcessId(json) {
		this.clinicalProcessId = json.clinicalProcessId
		return this
	}

	withTransportDateStr(json) {
		this.transportDateStr = json.transportDateStr
		return this
	}

	withTransportType(json) {
		this.transportType = json.transportType
		return this
	}

	withApplicantProcessId(json) {
		this.applicantProcessId = json.applicantProcessId
		return this
	}

	withEstablishmentName(json) {
		this.establishmentName = json.establishmentName
		return this
	}

	withEstablishmentId(json) {
		this.establishmentId = json.establishmentId
		return this
	}

	withState(json) {
		this.state = json.state
		return this
	}
}
